import { FiLinkedin } from 'react-icons/fi';

interface TeamMember {
  name: string;
  role: string;
  experience: string;
  passion: string;
  education: string;
  image?: string;
  linkedin?: string;
}

const team: TeamMember[] = [
  {
    name: "Yash Goyal",
    role: "Co-Founder",
    experience: "6+ years building analytics at JP Morgan and slice.",
    passion: "Now bringing the same data rigor to D2C brands.",
    education: "IIT Madras '19",
    image: "/team/yash.jpeg",
    linkedin: "https://www.linkedin.com/in/yash-goyal/",
  },
  {
    name: "Harshid Wasekar",
    role: "Co-Founder",
    experience: "7+ years shipping products at Tesco and Auquan.",
    passion: "Obsessed with building tech that moves real business metrics.",
    education: "BITS Pilani '18",
    image: "/team/harshid.jpeg",
    linkedin: "https://www.linkedin.com/in/harshid-wasekar/",
  },
  {
    name: "Kevin Pandya",
    role: "Co-Founder",
    experience: "7+ years building AI systems at JP Morgan and global hedge funds.",
    passion: "Passionate about applying these skills to solve e-commerce challenges.",
    education: "IIT Guwahati '18",
    image: "/team/kevin.png",
    linkedin: "https://www.linkedin.com/in/pandyakevin/",
  },
];

export default function TeamSection() {
  return (
    <section className="py-20 px-8 lg:px-16 bg-base-100">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Built by People Who Get It
          </h2>
          <p className="text-lg opacity-70 max-w-2xl mx-auto">
            Our team has spent years in data, analytics, and e-commerce. We built Gamgee because we saw how hard it is for merchants to get actionable insights.
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {team.map((member, index) => (
            <div key={index} className="card bg-base-200">
              <div className="card-body items-center text-center">
                {/* Avatar */}
                <div className="avatar mb-4">
                  {member.image ? (
                    <div className="w-24 rounded-full">
                      <img src={member.image} alt={member.name} />
                    </div>
                  ) : (
                    <div className="bg-primary text-primary-content w-24 rounded-full placeholder">
                      <span className="text-3xl">
                        {member.name.split(' ').map(n => n[0]).join('')}
                      </span>
                    </div>
                  )}
                </div>

                {/* Info */}
                <h3 className="card-title">{member.name}</h3>
                <p className="text-sm text-primary font-medium">{member.role}</p>
                <div className="text-sm opacity-70 mt-2 space-y-1">
                  <p>{member.experience}</p>
                  <p>{member.passion}</p>
                  <p className="opacity-60">{member.education}</p>
                </div>

                {/* Social Links */}
                <div className="flex gap-3 mt-4">
                  {member.linkedin && (
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-ghost btn-sm btn-square"
                    >
                      <FiLinkedin className="w-4 h-4" />
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
